<template>
    <div>
        <div class="row mb-3">
            <div class="col-12">
                <div class="ibox">
                    <div class="ibox-content">
                        <form @submit.prevent="setDeviceStatus">
                            <div class="row">
                                <div class="col-4">
                                    <label class="fs-11px">Eszközazonosító</label>
                                    <input type="text" class="form-control form-control-sm" v-model="add_form.manual_id" ref="device_input"
                                        required @focus="$event.target.select()">
                                </div>
                                <div class="col-6">
                                    <label class="fs-11px">mód:</label>
                                    <v-select class="border-0" v-model="add_form.isAtProject" :options="statuses"
                                        :reduce="option => option.id" label="name" :clearable="false" required>
                                    </v-select>
                                </div>
                                <div class="col-2">
                                    <button class="btn btn-primary" style="margin-top: 27px !important;">OK</button>
                                </div>
                            </div>
                            <div class="w-100 text-center" v-if="error">
                                <span class="badge bg-danger">{{ error }}</span>
                            </div>
                        </form>
                        <hr class="mb-2">
                        <div class="w-100 text-center" v-if="!rows">
                            <i class="fa fa-cog fa-spin"></i>
                            <h5>Hozzáadott eszközök betöltése...</h5>
                        </div>
                        <div v-else>
                            <vue-good-table :rows="rows" :columns="columns" row-style-class="fs-10px" styleClass="vgt-table condensed bordered"></vue-good-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table';
import appService from '../../apis/appService';

export default {
    components:{
        VueGoodTable
    },
    data(){
        return {
            statuses:[
                {id:true,name:"hozzáadás"},
                {id:false,name:"visszahozás"}
            ],
            add_form:{
                manual_id:null,
                isAtProject:true
            },
            rows:null,
            columns:[
                {
                    label: 'Eszközazonosító',
                    field: 'manual_id',
                    thClass: 'fs-10px',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés...'
                    }
                },
                {
                    label: 'Típus',
                    field: 'equipment_type',
                    thClass: 'fs-10px',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés...'
                    }
                },
                {
                    label: 'Státusz',
                    field: 'equipment_status',
                    thClass: 'fs-10px',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés...'
                    }
                },
            ],
            error:null
        }
    },
    computed: {
        lszsz() {
            return this.$store.state.lszsz;
        },
        user() {
            return this.$store.state.user;
        },
    },
    created(){
        this.$store.commit('updateSubTitle', 'Eszközkezelés');
        this.getData();
    },
    mounted() {
		this.$refs.device_input.focus();
	},
    methods:{
        getData(){
            appService.getDeviceList(this.user.project_id,this.lszsz,appService.getDeviceId()).then(response => {
                this.rows = response.data;
            })
        },
        setDeviceStatus(){
            appService.setDeviceStatus(this.user.project_id,this.lszsz,appService.getDeviceId(),this.add_form.manual_id,this.add_form.isAtProject).then(response => {
                console.log(response.data.msg);
                if(response.data.msg){
                    this.error = response.data.msg;
                }else{
                    this.getData();
                    this.add_form.manual_id = null;
                    this.error = null;
                }
                this.$refs.device_input.focus();
            })
        }
    }
}
</script>